module.exports = __webpack_public_path__ + "img/contract_status.c1e310f5.png";